'use strict';

var callDateGet = require('../../common/internal/callDateGet');

function getDate(d) {
  return callDateGet(d, 'Date');
}

module.exports = getDate;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/internal/getDate.js
// module id = 50
// module chunks = 0